export enum ScreenHint {
  SIGNUP = 'SIGNUP',
}
